"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var recompose_1 = require("recompose");

var withClickId = function withClickId(option) {
  var handler = option.event.reduce(function (previous, current) {
    previous[current] = function (props) {
      return function (event) {
        if (props[current]) {
          event.preventDefault();
          props[current]({
            id: event.currentTarget.id
          });
        }
      };
    };

    return previous;
  }, {});
  return recompose_1.withHandlers(handler);
};

exports["default"] = withClickId;